import { createI18n } from 'vue-i18n';
import ar from './langs/ar.json';
import en from './langs/en.json';
import tr from './langs/tr.json';

function loadLocaleMessages() {
  return {
    en,
    ar,
    tr
  };
}
const savedLocale = localStorage.getItem('locale') || 'en';
// export default createI18n({
//     locale: 'en',
//     fallbackLocale: 'en',
//     messages: loadLocaleMessages()
// })
const i18n = createI18n({
    legacy: false,
    locale: savedLocale, 
    fallbackLocale: 'en',
    messages: loadLocaleMessages(),
});

i18n.global.locale.value = savedLocale;

export default i18n;